import { useCallback, useState } from 'react';

const useToggle = (initialState) => {
  const [isActivated, setIsActivated] = useState(!!initialState);

  const activate = useCallback(() => {
    setIsActivated(true);
  }, []);

  const deactivate = useCallback(() => {
    setIsActivated(false);
  }, []);

  return { activate, deactivate, isActivated };
};

export default useToggle;
